"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingKey = void 0;
var SettingKey;
(function (SettingKey) {
    SettingKey["DEDUP_WINDOW_HOURS"] = "DEDUP_WINDOW_HOURS";
    SettingKey["MAX_MESSAGE_BYTES"] = "MAX_MESSAGE_BYTES";
    SettingKey["DLQ_DRAIN_MAX_SECONDS"] = "DLQ_DRAIN_MAX_SECONDS";
    SettingKey["DLQ_DRAIN_MAX_MESSAGES"] = "DLQ_DRAIN_MAX_MESSAGES";
    SettingKey["ALLOWED_PRODUCERS"] = "ALLOWED_PRODUCERS";
    // 0 = distributing normally, 1 = paused: every valid incoming request is
    // recorded as SUPPRESSED and no Distribution round is created, so nothing
    // reaches any vendor. Numeric (not boolean) to stay within SettingValue.
    SettingKey["DISTRIBUTION_PAUSED"] = "DISTRIBUTION_PAUSED";
    // Accounts that may act in the admin app; every other sharedresearch.jp account is view-only.
    SettingKey["ADMIN_EMAILS"] = "ADMIN_EMAILS";
    // Rules per producer other than SR Writer (domain/ProducerConfig.ts).
    SettingKey["PRODUCER_CONFIG"] = "PRODUCER_CONFIG";
    // Producers held back like DISTRIBUTION_PAUSED, but one at a time: a valid
    // request from one is recorded as SUPPRESSED and sent to no vendor (user,
    // 2026-10-08: sr-earnings stays held until it is given the go).
    SettingKey["PAUSED_PRODUCERS"] = "PAUSED_PRODUCERS";
    // Accounts that may use 手動配信 without being admins (user, 2026-10-16: the
    // English AI速報 is made outside the 速報レポート app and sent by hand for now).
    // They are otherwise view-only.
    SettingKey["MANUAL_SENDER_EMAILS"] = "MANUAL_SENDER_EMAILS";
    // Accounts that may write Yahoo!ファイナンス articles (Yahoo記事) without being admins.
    SettingKey["YAHOO_AUTHOR_EMAILS"] = "YAHOO_AUTHOR_EMAILS";
    // The analyst card on every Yahoo article: team coverage, so the company (domain/YahooArticle.ts).
    SettingKey["YAHOO_ANALYST"] = "YAHOO_ANALYST";
})(SettingKey || (exports.SettingKey = SettingKey = {}));
